import { useMutation } from '@tanstack/react-query';

import { networkApiCall } from '../lib/networking';
import { useModelInvalidateIndex } from '../hooks/queries';
import { RhinoResourceName } from '../index';

export const NOTIFICATION_MODEL = 'rhino_notification' as RhinoResourceName;

export const useNotificationsOpenAll = () => {
  const { invalidate } = useModelInvalidateIndex(NOTIFICATION_MODEL);

  return useMutation({
    mutationFn: () =>
      networkApiCall('/api/_rhino/notifications/open_all', { method: 'post' }),
    onSuccess: () => invalidate()
  });
};
